import axiosInstance from '@/plugins/api/axiosInstance';

export default function externalIntegration() {
    return {
        get,
        update
    };

    function get(integrationKey) {
        return axiosInstance.get(
            `external-integration/get?integrationKey=${integrationKey}`
        );
    }

    function update(data) {
        return axiosInstance.patch('external-integration/update', data);
    }
}
